import $ from "jquery"
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js"
import "../css/style.scss";

import ellipsis from "./components/ellipsis.js";
ellipsis();

$('.js-toggle-menu').click(function() {
    $('.l-header').toggleClass('is-collapse');
    $('.js-toggle-submenu').removeClass('is-opened');

    // Used when in desktop
    $('.l-header__subdropdown').addClass('is-collapse');
    $('.l-header').removeClass('has-submenu-open');
});

$( window ).scroll(function() {
    if (50 < $(window).scrollTop()) {
      $( "body" ).addClass("is-scrolled");
    } else {
      $( "body" ).removeClass("is-scrolled");
    }
});

$( document ).ready(function() {
    if (50 < $(window).scrollTop()) {
      $( "body" ).addClass("is-scrolled");
    } else {
      $( "body" ).removeClass("is-scrolled");
    }
});

$('.js-smooth-scroll')
.click(function(event) {
// On-page links
if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
    &&
    location.hostname == this.hostname
) {
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    // Does a scroll target exist?
    if (target.length) {
    // Only prevent default if animation is actually gonna happen
    event.preventDefault();
    $('html, body').animate({
        scrollTop: target.offset().top - 110
    }, 300);
    }
}
});
